import React, { useState } from "react";
import InputComponent from "../InputComponent/InputComponent";

const initialBankForm = {
  account_holder_name: "",
  bank: "",
  account_no: "",
  ifsc: "",
  upi_id: "",
};

const BankDetailForm = ({ onSubmit, isSubmitting }) => {
  const [transferMode, setTransferMode] = useState("banktransfer");
  const [form, setForm] = useState(initialBankForm);

  const setField = (field) => (value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      transfer_mode: transferMode,
      action: "add",
      account_holder_name: form.account_holder_name,
      bank: form.bank,
      account_no: form.account_no,
      ifsc: form.ifsc,
      upi_id: form.upi_id,
    });
  };

  const resetForm = () => setForm(initialBankForm);

  return (
    <form onSubmit={handleSubmit} className="border border-gray-200 rounded-lg p-3 bg-white">
      <h3 className="text-base font-semibold text-gray-800 mb-3">Add Bank Details</h3>

      <div className="flex gap-2 mb-4">
        <button
          type="button"
          className={`px-4 py-2 text-sm rounded-lg ${
            transferMode === "banktransfer"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 text-gray-700"
          }`}
          onClick={() => setTransferMode("banktransfer")}
        >
          Bank Account
        </button>
        <button
          type="button"
          className={`px-4 py-2 text-sm rounded-lg ${
            transferMode === "upi"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 text-gray-700"
          }`}
          onClick={() => setTransferMode("upi")}
        >
          UPI
        </button>
      </div>

      {transferMode === "banktransfer" ? (
        <div className="space-y-3">
          <InputComponent
            name="Account Holder Name"
            type="text"
            placeholder="Enter account holder name"
            value={form.account_holder_name}
            setValue={setField("account_holder_name")}
            required
          />
          <InputComponent
            name="Bank Name"
            type="text"
            placeholder="Enter bank name"
            value={form.bank}
            setValue={setField("bank")}
            required
          />
          <InputComponent
            name="Account Number"
            type="text"
            placeholder="Enter account number"
            value={form.account_no}
            setValue={setField("account_no")}
            required
          />
          <InputComponent
            name="IFSC Code"
            type="text"
            placeholder="Enter IFSC code"
            value={form.ifsc}
            setValue={setField("ifsc")}
            required
          />
        </div>
      ) : (
        <InputComponent
          name="UPI ID"
          type="text"
          placeholder="Enter UPI ID"
          value={form.upi_id}
          setValue={setField("upi_id")}
          required
        />
      )}

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="button"
          className="btn btn-outline-primary px-4 py-2 text-sm"
          onClick={resetForm}
        >
          Clear
        </button>
        <button
          type="submit"
          disabled={isSubmitting}
          className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 disabled:opacity-60"
        >
          {isSubmitting ? "Adding..." : "Add"}
        </button>
      </div>
    </form>
  );
};

export default BankDetailForm;
